import { FormViewMode } from '../../types';
export const setSelectedFormStoreState = formStoreState => ({
  setState
}) => {
  setState({
    selectedFormStoreState: formStoreState,
    formViewMode: FormViewMode.View
  });
};